import { render, staticRenderFns } from "./LoginLocal.vue?vue&type=template&id=789dc033&"
import script from "./LoginLocal.vue?vue&type=script&lang=js&"
export * from "./LoginLocal.vue?vue&type=script&lang=js&"
import style0 from "./LoginLocal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports